import { memo } from 'react';
import { classNames } from 'src/utils/classNames';

type Props = {
  text: string;
  size?: 'default' | 'sm' | 'md' | 'full';
  active?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  testId?: string;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
};

export const Button = memo(
  ({ text, onClick, disabled, size = 'default', active = true, testId, className, type = 'button' }: Props) => {
    const buttonSizeStyle = `button-${size}`;
    const buttonColorStyle = active ? 'text-white bg-green border-none' : 'text-white bg-gray3';

    return (
      <button
        className={classNames(
          className,
          'disabled:bg-gray',
          'disabled:cursor-not-allowed',
          buttonSizeStyle,
          buttonColorStyle,
        )}
        type={type}
        onClick={onClick}
        disabled={!!disabled}
        data-testid={testId}
      >
        {text}
        <style jsx>{`
          .button-default {
            outline: none;
            border-radius: 34px;
            width: 280px;
            height: 50px;
            padding: 11px 0;
            font-size: 18px;
            font-weight: 600;
            text-align: center;
            margin: 15px 0;
          }
          .button-sm {
            padding: 0px 14px 2px 14px;
            font-size: 14px;
            text-align: center;
            outline: none;
            border-radius: 34px;
            width: auto;
            height: 27px;
          }
          .button-md {
            padding: 0px 14px 2px 14px;
            font-size: 14px;
            text-align: center;
            outline: none;
            border-radius: 34px;
            width: 145px;
            height: 35px;
          }
          .button-full {
            padding: 0px 14px 2px 14px;
            font-size: 18px;
            font-weight: 600;
            text-align: center;
            outline: none;
            border-radius: 34px;
            width: 100%;
            height: 50px;
          }
        `}</style>
      </button>
    );
  },
);
